export default __webpack_public_path__ + "44a0fc855fd243c6c972bd804408428c.png";